import React, { useState } from "react";

const DeleteAccount = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");

  const handleDelete = (e: any) => {
    e.preventDefault();
    if (!email) {
      setError("Email is required");
      return;
    }
    // Here you can handle the deletion logic, for example, send a request to your server.
    setMessage("Your account deletion request has been submitted.");
    setError("");
  };

  return (
    <div className="flex flex-col items-center gap-6 p-6 max-w-md mx-auto bg-white shadow-lg rounded-lg mt-10">
      <h1 className="text-3xl font-bold text-gray-800">Delete Account</h1>
      <p className="text-gray-600">
        Enter your email address below to delete your account. Please note that
        this action is irreversible.
      </p>
      {message && <p className="text-green-600">{message}</p>}
      {error && <p className="text-red-600">{error}</p>}
      <form onSubmit={handleDelete} className="w-full flex flex-col gap-4">
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Enter your email"
          className="w-full p-3 border border-gray-300 rounded-lg"
        />
        <button
          type="submit"
          className="w-full p-3 bg-red-600 text-white font-bold rounded-lg hover:bg-red-700"
        >
          Delete My Account
        </button>
      </form>
    </div>
  );
};

export default DeleteAccount;
